module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-hr-1-6326a1fe843c58d0d97857a277ce36eb.png";